/*
 * Copyright (C) iSchoolConnect - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { CLIENT_TRIGGERED_EVENTS, SERVER_TRIGGERED_EVENTS } from '../types';
import { LoggerService } from './LoggerService';
// import { StorageService } from './StorageService';

const API_URL = process.env.REACT_APP_API_URL as string;

interface TenantNotification {
	count: number;
}

// setups socket
// handles events
// forwards those events to the caller via the subject
// closes socket
export class TenantNotificationService {
	notifications$ = new Subject<TenantNotification>();

	accessToken: string | null;

	private socket: Socket | null = null;

	constructor(token: string | null) {
		this.accessToken = token;
	}

	// Socket
	private setupSocket() {
		this.socket = io(`${API_URL}/push-notification-tenant`, {
			transports: ['websocket'],
			reconnection: true,
			auth: {
				accessToken: this.accessToken,
			},
		});
		const onConnection = () => {
			// eslint-disable-next-line no-console
			console.log('Tenant Socket connected...');
			this.socket?.emit(CLIENT_TRIGGERED_EVENTS.JOIN, {});
		};
		const onDisconnection = () => {
			// TODO: Some handling
			// eslint-disable-next-line no-console
			console.log('Socket disconnected...');
		};
		const onWaitingGuestsCountUpdate = (countUpdate: TenantNotification) => {
			this.notifications$.next(countUpdate);
		};
		this.socket.on('connect', onConnection);
		this.socket.on('disconnect', onDisconnection);
		this.socket.on(SERVER_TRIGGERED_EVENTS.WAITING_GUESTS, onWaitingGuestsCountUpdate);
		this.socket.on('exception', LoggerService.logError);
	}

	init(): void {
		this.setupSocket();
	}

	close(): void {
		this.socket?.disconnect();
	}
}
